import clsx from 'clsx'

/**
 * Corpo do desafio — a única região rolável da tela.
 *
 * A altura sai da composição de flex: `flex-1` toma o espaço que sobra entre
 * toolbar e footer, e `min-h-0` é o que permite encolher abaixo do conteúdo (o
 * `min-height: auto` padrão de item flex impediria, e o `overflow-y-auto` nunca
 * ativaria — a coluna estouraria em vez de rolar).
 *
 * Antes daqui a altura era calculada em JS, medindo `offsetHeight` de wrapper,
 * toolbar, header e footer no mount e a cada `resize`. Isso não acompanhava o
 * colapso da barra de endereço no iOS nem a abertura do teclado (não havia
 * listener em `visualViewport`), e era a causa do footer solto no mobile.
 *
 * `noClasses` dispensa o gutter e o scroll, mas **não** as classes estruturais:
 * quem usa essa saída (as stories) posiciona filhos com `h-full`, que só resolve
 * contra uma altura definida.
 */
export const Body = ({
  id,
  noClasses = false,
  className = '',
  children,
  ...rest
}) => (
  <div
    id={`level-play-body${id}`}
    className={clsx(
      'min-h-0 flex-1',
      !noClasses && 'overflow-y-auto px-4',
      className
    )}
    {...rest}
  >
    {noClasses ? (
      children
    ) : (
      <div className="mx-auto flex w-full max-w-[550px] flex-col">
        {children}
      </div>
    )}
  </div>
)
